import { Footer } from '../../../components/footer'
import FooterNotify from './FooterNotify'
import type { FooterNotifyProps } from './FooterNotify'
import { FooterButton } from './FooterButton'
import type { FooterButtonProps } from './FooterButton'

type DetailFooterProps = FooterButtonProps & FooterNotifyProps

export default function DetailFooter({
  activeProductSale,
  overallStatus,
  subscriptionStatus,
  subscriptionStatusLabel,
}: DetailFooterProps) {
  return (
    <Footer background="fill">
      <FooterNotify activeProductSale={activeProductSale} overallStatus={overallStatus} />
      <FooterButton subscriptionStatus={subscriptionStatus} subscriptionStatusLabel={subscriptionStatusLabel} />
    </Footer>
  )
}
